import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Products from './pages/Products';
import Careers from './pages/Careers';
import ContactUs from './pages/ContactUs';
import ScrollToTopButton from './components/ScrollToTopButton';
import './App.css';
import ScrollToTop from './components/ScrollToTop';
import ServiceSection from './pages/ServiceSection';
import ProductWedoo from './pages/ProductWedoo';
import ProductTrustmee from './pages/ProductTrustmee';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <ScrollToTop />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/services/section/:id" element={<ServiceSection />} />
            <Route path="/product-wedoo" element={<ProductWedoo />} />
            <Route path="/product-trustmee" element={<ProductTrustmee />} />
          </Routes>
        </main>
         <ScrollToTopButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;